var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.057,
    height: 27.44,
    viewBox: "0 0 25.057 27.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(0.283 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90744",
    "data-name": "Path 90744",
    d: "M26.246,26.817h-20A2.245,2.245,0,0,1,4.9,22.776l1.008-.756a1.829,1.829,0,0,0,.71-1.171l1.265-7.68a8.462,8.462,0,0,1,16.727.007l1.264,7.674a1.829,1.829,0,0,0,.71,1.171l1.009.756a2.245,2.245,0,0,1-1.347,4.041Zm-10-19.592a7.2,7.2,0,0,0-7.155,6.136L7.825,21.047A3.048,3.048,0,0,1,6.642,23l-1.009.757a1.02,1.02,0,0,0,.612,1.837h20a1.02,1.02,0,0,0,.612-1.836L25.849,23a3.048,3.048,0,0,1-1.184-1.951L23.4,13.367a7.2,7.2,0,0,0-7.154-6.143Z",
    transform: "translate(-4 -3.551)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90745",
    "data-name": "Path 90745",
    d: "M24.286,5.894a.612.612,0,0,1-.612-.612V4.449a1.225,1.225,0,1,0-2.449,0v.833a.612.612,0,1,1-1.225,0V4.449a2.449,2.449,0,1,1,4.9,0v.833A.612.612,0,0,1,24.286,5.894Z",
    transform: "translate(-10.204 -2)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90746",
    "data-name": "Path 90746",
    d: "M21.286,42.9A4.291,4.291,0,0,1,17,38.612a.612.612,0,1,1,1.225,0,3.061,3.061,0,1,0,6.123,0,.612.612,0,0,1,1.225,0A4.291,4.291,0,0,1,21.286,42.9Z",
    transform: "translate(-9.04 -15.959)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.511abc87a76afcbb08843690c118f82f.svg";
export { ForwardRef as ReactComponent };